module.exports = __webpack_public_path__ + "img/multimedia.a154592b.svg";